


  function showProductDescription(){
    document.getElementById("cto-product-description").classList.add("selectedTab");
    document.getElementById("cto-product-description").classList.remove("unselectedTab");

    document.getElementById("cto-product-documentation").classList.add("unselectedTab");
    document.getElementById("cto-product-documentation").classList.remove("selectedTab");

    document.getElementById("cto-build-summary").classList.add("unselectedTab");
    document.getElementById("cto-build-summary").classList.remove("selectedTab");

    document.getElementById("cto-product-description-btn").classList.add("selectedTabBtn");
    document.getElementById("cto-product-documentation-btn").classList.remove("selectedTabBtn");
    document.getElementById("cto-build-summary-btn").classList.remove("selectedTabBtn");
    document.getElementById("mobile-cto-show-all-btn").style.display = "none";

    if (window.innerWidth < 768) document.getElementById("cto_div").style.transform = "translateY(0px)";


  }
  function showBuildSummary(){
    document.getElementById("cto-product-description").classList.add("unselectedTab");
    document.getElementById("cto-product-description").classList.remove("selectedTab");

    document.getElementById("cto-product-documentation").classList.add("unselectedTab");
    document.getElementById("cto-product-documentation").classList.remove("selectedTab");

    document.getElementById("cto-build-summary").classList.add("selectedTab");
    document.getElementById("cto-build-summary").classList.remove("unselectedTab");

    document.getElementById("cto-product-description-btn").classList.remove("selectedTabBtn");
    document.getElementById("cto-product-documentation-btn").classList.remove("selectedTabBtn");
    document.getElementById("cto-build-summary-btn").classList.add("selectedTabBtn");

    document.getElementById("mobile-cto-show-all-btn").style.display = "flex";
    if (window.innerWidth < 768) document.getElementById("cto_div").style.transform = "translateY(-30px)";


  }

    function showProductDocumentation(){
        document.getElementById("cto-product-documentation").classList.add("selectedTab");
        document.getElementById("cto-product-documentation").classList.remove("unselectedTab");

        document.getElementById("cto-product-description").classList.remove("selectedTab");
        document.getElementById("cto-product-description").classList.add("unselectedTab");

        document.getElementById("cto-build-summary").classList.add("unselectedTab");
        document.getElementById("cto-build-summary").classList.remove("selectedTab");

        document.getElementById("cto-product-description-btn").classList.remove("selectedTabBtn");
        document.getElementById("cto-product-documentation-btn").classList.add("selectedTabBtn");
        document.getElementById("cto-build-summary-btn").classList.remove("selectedTabBtn");
        document.getElementById("mobile-cto-show-all-btn").style.display = "none";
        if (window.innerWidth < 768) document.getElementById("cto_div").style.transform = "translateY(0px)";


    }





async function fetchEntry(type, entryID) {
    const apiUrl = `https://apiapi.ombligo.com/n_contentful/entry/${type}/${entryID}/`;

    try {
        const response = await fetch(apiUrl);
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

async function retrieveLinkedTechTalks(resources) {    
    for (const resource of resources) {
        let resourceID = resource.sys.id;
        let entry = await fetchEntry("entries", resourceID);
        if (entry && entry.fields) {
            var resourceData = entry.fields;
            await setupCTOContentResources(resourceData);
        }
    }
}

async function setupCTOContentResources(data) {
    var CTOContentResourcesContainer = document.querySelector('#CTOContentResourcesContainer');
    var resourceData = data;
    var resourceLink = resourceData.linkToResource;
    var resourceDescription = resourceData.description.content;

    var image = await fetchEntry("assets", resourceData.image.sys.id);
    var imageURL = image.fields.file.url.replace('//', 'https://');
    var imageDescription = image.fields.description;

    var parsedDescription = '';

    resourceDescription.forEach(node => {
        parsedDescription += parseRichText(node);
    });

    const resourceContainer = document.createElement('div');
    resourceContainer.classList.add('resourceContainer');

    const resourceImageContainer = document.createElement('div');
    resourceImageContainer.classList.add('resourceImageContainer');

    const resourceImage = document.createElement('img');
    resourceImage.src = imageURL;
    resourceImage.alt = imageDescription;
    resourceImage.classList.add('resourceImage');

    const resourceTitle = document.createElement('h3');
    resourceTitle.classList.add('resourceTitle');
    resourceTitle.innerHTML = resourceData.title;

    const resourceDescriptionContainer = document.createElement('div');
    resourceDescriptionContainer.id = resourceData.title.replaceAll(' ', '_');
    resourceDescriptionContainer.classList.add('resourceDescriptionContainer');
    resourceDescriptionContainer.innerHTML = parsedDescription;

    const resourceLinkElem = document.createElement('a');
    resourceLinkElem.classList.add('resourceLink');
    resourceLinkElem.href = resourceLink;
    resourceLinkElem.title = resourceData.title;

    resourceImageContainer.appendChild(resourceImage);
    resourceLinkElem.appendChild(resourceImageContainer);
    resourceLinkElem.appendChild(resourceTitle);
    resourceLinkElem.appendChild(resourceDescriptionContainer);
    resourceContainer.appendChild(resourceLinkElem);
    CTOContentResourcesContainer.appendChild(resourceContainer);
}

async function setupCTOContentData(data) {
    title = data.fields.sectionTitle;
    sectionDescription = data.fields.sectionDescription.content;
    resourcesToDisplay = data.fields.resourcesToDisplay;
    let parsedDescription = '';

    sectionDescription.forEach(node => {
        parsedDescription += parseRichText(node);
    });

    fillTitleText(title, "#CTOContentTitle");
    fillDescriptionText(parsedDescription, "#CTOContentDescription");
    await retrieveLinkedTechTalks(resourcesToDisplay);
}

function fillSubtitleText(data) {
    subtitleContainer = document.querySelector('#collection_subtitle');
    subtitleContainer.innerHTML = data;
}



function parseRichText(node) {
    if (node.nodeType === 'text') {
        let text = node.value;
        text = text.replace('\n', "<br>");
        if (node.marks) {
            node.marks.forEach(mark => {
                if (mark.type === 'bold') {
                    text = `<strong>${text}</strong>`;
                }
                if (mark.type === 'italic') {
                    text = `<em>${text}</em>`;
                }
                if (mark.type === 'underline') {
                    text = `<u>${text}</u>`;
                }

            });
        }
        return text;

        } else if (node.nodeType === 'hyperlink') {
            return `<a title="${node.content.map(parseRichText)}" href="${node.data.uri}">${node.content.map(parseRichText).join('')}</a>`;
        } else if (node.nodeType === 'paragraph') {
            return `<p>${node.content.map(parseRichText).join('')}</p>`;
        } else if (node.nodeType === 'document') {
            return node.content.map(parseRichText).join('');
        }
    return '';
    }


//mainImage

function updateMainImage(){
    const mainImage = document.querySelector('.mainImage');
    if (!mainImage) {
        return;
    }
    let mainImageSrc = mainImage.getAttribute('src');

    if (mainImageSrc && mainImageSrc.includes('300x300')) {
        mainImageSrc = mainImageSrc.replace('_300x300', '');
    }
    mainImage.setAttribute('src', mainImageSrc);
}
